import { call, put, takeLatest } from 'redux-saga/effects';
import { OP } from "../../constant";
import { doAddStaff, doFetchStaff, doViewStaff, doEditStaff, doDeactivateStaff, doApproveStaff, doRejectStaff, doActivateStaff, doResetStaffPassword, doUnblockStaff } from '../../service/staff'

import errorMessage from "../../utils/error.json";


/* ------------------------- STAFF SAGA --------------------- */
// fetch staff list
function* fetchStaffTask(action) {
    try {
        yield put({ type: OP.STAFF_LIST_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doFetchStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.STAFF_LIST_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.STAFF_LIST_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.STAFF_LIST_FAILURE,
            payload: errMsg
        })
    }
}

// add staff
function* addStaffTask(action) {
    try {
        yield put({ type: OP.ADD_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doAddStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.ADD_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.ADD_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.ADD_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// view staff
function* viewStaffTask(action) {
    try {
        yield put({ type: OP.VIEW_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doViewStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.VIEW_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.VIEW_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.VIEW_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// edit staff
function* editStaffTask(action) {
    try {
        yield put({ type: OP.EDIT_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doEditStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.EDIT_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.EDIT_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.EDIT_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// activate staff
function* activateStaffTask(action) {
    try {
        yield put({ type: OP.ACTIVATE_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doActivateStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.ACTIVATE_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.ACTIVATE_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.ACTIVATE_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// deactivate staff
function* deactivateStaffTask(action) {
    try {
        yield put({ type: OP.DEACTIVATE_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doDeactivateStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.DEACTIVATE_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.DEACTIVATE_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.DEACTIVATE_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// approve Staff
function* approveStaffTask(action) {
    try {
        yield put({ type: OP.APPROVE_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doApproveStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.APPROVE_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.APPROVE_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.APPROVE_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// reject Staff
function* rejectStaffTask(action) {
    try {
        yield put({ type: OP.REJECT_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doRejectStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.REJECT_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.REJECT_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.REJECT_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// reset Staff password
function* resetStaffPasswordTask(action) {
    try {
        yield put({ type: OP.RESET_STAFF_PASSWORD_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doResetStaffPassword, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.RESET_STAFF_PASSWORD_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.RESET_STAFF_PASSWORD_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.RESET_STAFF_PASSWORD_FAILURE,
            payload: errMsg
        })
    }
}

// unblock Staff
function* unblockStaffStaffTask(action) {
    try {
        yield put({ type: OP.UNBLOCK_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doUnblockStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.UNBLOCK_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.UNBLOCK_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.UNBLOCK_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

function* staffSaga() {
    yield takeLatest(OP.STAFF_LIST_REQUEST, fetchStaffTask);
    yield takeLatest(OP.ADD_STAFF_REQUEST, addStaffTask);
    yield takeLatest(OP.VIEW_STAFF_REQUEST, viewStaffTask);
    yield takeLatest(OP.EDIT_STAFF_REQUEST, editStaffTask);
    yield takeLatest(OP.ACTIVATE_STAFF_REQUEST, activateStaffTask);
    yield takeLatest(OP.DEACTIVATE_STAFF_REQUEST, deactivateStaffTask);
    yield takeLatest(OP.APPROVE_STAFF_REQUEST, approveStaffTask);
    yield takeLatest(OP.REJECT_STAFF_REQUEST, rejectStaffTask);
    yield takeLatest(OP.RESET_STAFF_PASSWORD_REQUEST, resetStaffPasswordTask);
    yield takeLatest(OP.UNBLOCK_STAFF_REQUEST, unblockStaffStaffTask);
}

export default staffSaga;